/* eslint-disable react/destructuring-assignment */
/* eslint-disable quotes */
import React, { useEffect, useState, useRef } from "react";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import uniqBy from 'lodash/uniqBy';
import { Autocomplete } from "@workboard/wobo-ui";
import { hot } from "react-hot-loader/root";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import Menu from "../../styled-base/menu";
import { ScheduledPopUp } from './ScheduledPopUp';
import { getAiTypeActionLabel } from "../../board/utils";

class PreferenceApp extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      dailyDigestEmailPreference: this.props.preferenceData.preference
        .dailyDigestEmailPreference,
      dailyDueEmailPreference: this.props.preferenceData.preference
        .dailyDueEmailPreference,
      delegatedAIEmailPreference: this.props.preferenceData.preference
        .delegatedAIEmailPreference,
      dontSendMeAnyEmails: this.props.preferenceData.preference
        .dontSendMeAnyEmails,
      loopedAIEmailPreference: this.props.preferenceData.preference
        .loopedAIEmailPreference,
      okrUpdatesPreference: this.props.preferenceData.preference
        .okrUpdatesPreference,
      myAIEmailPreference: this.props.preferenceData.preference
        .myAIEmailPreference,
      reportDueEmailPreference: this.props.preferenceData.preference
        .reportDueEmailPreference,
      startPagePreference: this.props.preferenceData.preference
        .startPagePreference,
      startPageRBRId: this.props.preferenceData.preference
        .startPageRBRId,
      startPageScorecardId: this.props.preferenceData.preference
        .startPageScorecardId,
      scorecardError: false,
      disableHeatmap: this.props.preferenceData.preference.disableHeatmap,
      tooltip: this.props.preferenceData.preference.tooltip,
      updateMetricAiEmail: this.props.preferenceData.preference
        .updateMetricAiEmail,
      // useVNext: this.props.preferenceData.preference
      //   .useVNext,
      workViewPagePref: this.props.preferenceData.preference.workViewPagePref,
      successMsg: "",
      bestPracticesTips: this.props.preferenceData.preference.bestPracticesTips,
      calib_teams: this.props.preferenceData.preference.notifications.calib_teams,
      celeb_teams: this.props.preferenceData.preference.notifications.celeb_teams,
      calib_teams_nudge_on: this.props.preferenceData.preference.notifications.calib_teams_nudge_on,
      showCnC: this.props.preferenceData.preference.showCnC,
      showCnCEmail: this.props.preferenceData.preference.showCnCEmail,
      showSlack: this.props.preferenceData.preference.showSlack,
      showTeams: this.props.preferenceData.preference.showTeams,
      showWebex: this.props.preferenceData.preference.showWebex,
      cncForEmail: this.props.preferenceData.preference.notifications.cncForEmail,
      cncForSlack: this.props.preferenceData.preference.notifications.cncForSlack,
      cncForTeams: this.props.preferenceData.preference.notifications.cncForTeams,
      cncForWebex: this.props.preferenceData.preference.notifications.cncForWebex,
      cncForManager: this.props.preferenceData.preference.notifications.cncForManager,
      cncForCoManager: this.props.preferenceData.preference.notifications.cncForCoManager,
      cncForNonManager: this.props.preferenceData.preference.notifications.cncForNonManager,
      cncGenAiSummaryBrief: this.props.preferenceData.preference.notifications.cncGenAiSummaryBrief,
      showFeedbackSlack: this.props.preferenceData.preference.showFeedbackSlack,
      showFeedbackTeams: this.props.preferenceData.preference.showFeedbackTeams,
      showFeedback: this.props.preferenceData.preference.showFeedback,
      showFeedbackEmail: this.props.preferenceData.preference.showFeedbackEmail,
      feedbackForEmail: this.props.preferenceData.preference.notifications.feedbackForEmail,
      feedbackForSlack: this.props.preferenceData.preference.notifications.feedbackForSlack,
      feedbackForTeams: this.props.preferenceData.preference.notifications.feedbackForTeams,


    };
    this.handleChange = this.handleChange.bind(this);
    this.handleNewChange = this.handleNewChange.bind(this);
    this.CollectInputValue = this.CollectInputValue.bind(this);
    this.initPendoVisitorReport = this.initPendoVisitorReport.bind(this);
  }

  componentDidMount () {
    this.initPendoVisitorReport();
  }

  initPendoVisitorReport() {
    if (this.props.preferenceData?.isPendoEnabled) {
      window.trackPendoVisitorReport?.();
    }
  }

  handleChange (e, res) {
    const { name } = e.target;
    const value = res;
    const { state } = this;
    state[name] = value;
    if (name == "dontSendMeAnyEmails" && value == false) {
      setTimeout(
        () =>
          this.setState({
            dontSendMeAnyEmails: value,
            dailyDueEmailPreference: true,
            dailyDigestEmailPreference: true,
            loopedAIEmailPreference: true,
            okrUpdatesPreference: true,
            bestPracticesTips: true,
            reportDueEmail: true,
            okrUpdates: true,
          }),
        100
      );
    } else if (name == "dontSendMeAnyEmails" && value == true) {
      setTimeout(
        () =>
          this.setState({
            dontSendMeAnyEmails: value,
            dailyDueEmailPreference: false,
            dailyDigestEmailPreference: false,
            loopedAIEmailPreference: false,
            okrUpdatesPreference: false,
            bestPracticesTips: false,
            reportDueEmail: false,
            okrUpdates: false,
          }),
        100
      );
    } else {
      this.setState({
        state
      }, () => {
        if (this.state.dontSendMeAnyEmails == false &&
          this.state.dailyDueEmailPreference == false &&
          this.state.dailyDigestEmailPreference == false &&
          this.state.loopedAIEmailPreference == false &&
          this.state.okrUpdatesPreference == false &&
          this.state.bestPracticesTips == false &&
          this.state.delegatedAIEmailPreference == false &&
          this.state.myAIEmailPreference == false
        ) {
          setTimeout(
            () =>
              this.setState({
                dontSendMeAnyEmails: true,
              }),
            100
          );
        }
      });
    }

    setTimeout(() => this.CollectInputValue(this.state), 200);
  }

  handleNewChange (nameVal, res) {
    const name = nameVal;
    const value = res;
    const { state } = this;
    state[name] = value;
    this.setState(state);
    this.CollectInputValue(this.state);
  }

  CollectInputValue (e) {
    const { t } = this.props
    const { profiles } = this.props.preferenceData;
    const { model } = this.props.preferenceData;
    const profileInfo = {};
    const userinfo = {};
    const updateProfileInfo = {};
    const userChangePasswordInfo = {};
    profileInfo.first_name = profiles.first_name;
    profileInfo.last_name = profiles.last_name;
    profileInfo.title = profiles.title;
    profileInfo.company = profiles.company;
    profileInfo.company_ccid = profiles.ccid;
    profileInfo.selected_company = profiles.company;
    userinfo.email = model.email;
    userinfo.cell_num = model.cell_num;
    userinfo.timezone = model.timezone;
    updateProfileInfo.newEmail = "";
    updateProfileInfo.verifyEmail = "";
    userChangePasswordInfo.oldPassword = "";
    userChangePasswordInfo.password = "";
    userChangePasswordInfo.verifyPassword = "";

    const params = {
      profile: profileInfo,
      User: userinfo,
      UpdateProfile: updateProfileInfo,
      UserChangePassword: userChangePasswordInfo,
    };

    if (this.state.tooltip) {
      params.tooltip = this.state.tooltip;
    }
    if (this.state.workViewPagePref != "") {
      params.workViewPagePref = this.state.workViewPagePref;
    }
    if (this.state.startPagePreference != "") {
      params.startPagePref = this.state.startPagePreference;
      params.startPageScorecardId = this.state.startPageScorecardId;
      if (params.startPagePref == 7 && this.state.startPageRBRId !== null) {
        params.startPageRBRId = this.state.startPageRBRId;
      }
    }

    if (this.state.dontSendMeAnyEmails == true) {
      params.dontSendMeAnyEmails = 1;
      params.dailyDueEmail = false;
      params.dailyDigestEmail = false;
      params.myAiEmail = false;
      params.okrUpdates = false;
      params.bestPracticesTips = false;
      params.reportDueEmail = false;
      params.okrUpdates = false;
    } else {
      params.dontSendMeAnyEmails = this.state.dontSendMeAnyEmails;
      params.dailyDueEmail = this.state.dailyDueEmailPreference;
      params.dailyDigestEmail = this.state.dailyDigestEmailPreference;
      params.myAiEmail = this.state.loopedAIEmailPreference;
      params.okrUpdates = this.state.okrUpdatesPreference;
      params.bestPracticesTips = this.state.bestPracticesTips;
      params.reportDueEmail = this.state.reportDueEmailPreference;
      params.loopedAIEmail = this.state.loopedAIEmailPreference;
    }

    if (this.state.showCnC) {
      params.calib_teams = this.state.calib_teams;
      params.celeb_teams = this.state.celeb_teams;
      params.calib_teams_nudge_on = this.state.calib_teams_nudge_on;
      params.cncForManager = this.state.cncForManager;
      params.cncForCoManager = this.state.cncForCoManager;
      params.cncForNonManager = this.state.cncForNonManager;
      params.cncGenAiSummaryBrief = this.state.cncGenAiSummaryBrief;

      if (this.state.showCnCEmail) {
        params.cncForEmail = this.state.cncForEmail;
      }

      if (this.state.showSlack) {
        params.cncForSlack = this.state.cncForSlack;
      }

      if (this.state.showTeams) {
        params.cncForTeams = this.state.cncForTeams;
      }

      if (this.state.showWebex) {
        params.cncForWebex = this.state.cncForWebex;
      }
    }

    if (this.state.showFeedback) {
      if (this.state.showFeedbackEmail) {
        params.feedbackForEmail = this.state.feedbackForEmail;
      }

      if (this.state.showFeedbackSlack) {
        params.feedbackForSlack = this.state.feedbackForSlack;
      }

      if (this.state.showFeedbackTeams) {
        params.feedbackForTeams = this.state.feedbackForTeams;
      }
    }

    params.updateMetricAiEmail = this.state.updateMetricAiEmail;
    params.preferenceData = 1;
    params.returnData = true;
    showLoaderWidget($('#content'));
    const _this = this;
    $.ajax({
      url: `${wbConfig.baseUrl}/user/profile/myPreferences`,
      type: "POST",
      dataType: 'json',
      data: params,
    }).done((resp) => {
      _this.setState({ successMsg: t("Profile Updated") });
      setTimeout(() => _this.setState({ successMsg: "" }), 2000);
      removeLoaderWidget();
      if (this.props.preferenceData.preference.startPagePreference != params.startPagePref) {
        const url = resp?.preference?.startPageUrl ??  "#";
        // this does not work.  vNext does not put the orglogo in the class name
        if (document.getElementsByClassName('orglogo') && document.getElementsByClassName('orglogo')[0] && document.getElementsByClassName('orglogo')[0].children[0]) {
          const orgElement = document.getElementsByClassName('orglogo')[0].children[0];
          if (orgElement) {
            orgElement.href = wbConfig.baseUrl + url;
          }
        }
      }
    });
  }

  render () {
    const { t } = this.props;
    const { preferenceData } = this.props;
    const { preference, userTimeOff, profiles, isEntCust } = preferenceData;
    const { notifications } = preference;
    const goalModule = this.props.preferenceData.goalModule || false;
    const executeModule = this.props.preferenceData.executeModule || false;
    return (
      <div
        id="tm_"
        className="tmMr tmBodyText"
        style={{ backgroundColor: "#ffffff", marginTop: "3px" }}
      >
        <h1 style={{ width: "80%" }} className="settingHeader">
          {t("Preferences")}
          <div
            className="preferencesSuccess"
            style={{
              float: "right",
              display: "inline-block",
            }}
          >
            &nbsp;&nbsp;{this.state.successMsg}
          </div>
        </h1>
        <div className="profileComp">
          <div className="profileContent">
            <div className="pfSettingsMainDiv">
              <div className="preferencesSubHeader">
                {t("Email Preferences")}
              </div>

              <EmailPreferences
                preference={preference}
                state={this.state}
                handleChange={this.handleChange}
                profiles={profiles}
                executeModule={executeModule}
                goalModule={goalModule}
                t={t}
              />

              {preferenceData.preference.showFeedback && (
                <div className="preferencesSubHeader" style={{ paddingTop: '30px' }}>
                  {t('Feedback Notification Preferences')}
                </div>
              )}

              {preferenceData.preference.showFeedback && (
                <FeedbackPreferences
                  notifications={notifications}
                  state={this.state}
                  handleChange={this.handleChange}
                  showFeedback={preferenceData.preference.showFeedback}
                  showFeedbackEmail={preferenceData.preference.showFeedbackEmail}
                  showFeedbackSlack={preferenceData.preference.showFeedbackSlack}
                  showFeedbackTeams={preferenceData.preference.showFeedbackTeams}
                  t={t}
                />
              )}

              {preferenceData.preference.showCnC &&
              <div className="preferencesSubHeader" style={{ paddingTop: '30px' }}>{t("Calibrate & Celebrate Preferences")}</div>}

              {preferenceData.preference.showCnC &&
              <CalibrateCelebratePreferences
                notifications={notifications}
                state={this.state}
                handleChange={this.handleChange}
                showCnC={preferenceData.preference.showCnC}
                showCnCEmail={preferenceData.preference.showCnCEmail}
                showSlack={preferenceData.preference.showSlack}
                showTeams={preferenceData.preference.showTeams}
                showWebex={preferenceData.preference.showWebex}
                t={t}
              /> }
              <div id="profileUserDetailSpacerRow" />

              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#333333",
                  padding: "30px 0 10px 20px",
                }}
              >
                {t("Tools")}
              </div>
              <Tools
                preference={preference}
                state={this.state}
                handleChange={this.handleChange}
                isEntCust={isEntCust}
                goalModule={goalModule}
                executeModule={executeModule}
                t={t}
              />
              <div id="profileUserDetailSpacerRow"> </div>

              {executeModule && (
                <ScheduledTimeOff
                  userTimeOff={userTimeOff}
                  actions={this.props.actions}
                  t={t}
                />
              )}
            </div>

            <div className="preferencePic">
              {executeModule && (
                <div>
                  <div className="picHeader">{t("Workstream View Preferences")} </div>
                  <WorkstreamViewPreferences
                    preference={preference}
                    state={this.state}
                    handleChange={this.handleChange}
                    handleNewChange={this.handleNewChange}
                    t={t}
                  />
                  <div id="profileUserDetailSpacerRow" />
                </div>
              )}
              <div className="picHeader">{t("Start Page")}</div>
              <StartPage
                preference={preference}
                state={this.state}
                handleChange={this.handleChange}
                isEntCust={isEntCust}
                goalModule={goalModule}
                executeModule={executeModule}
                handleNewChange={this.handleNewChange}
                t={t}
              />
              <div id="profileUserDetailSpacerRow" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class EmailPreferences extends React.Component {
  constructor (props) {
    super(props);
    this.susbscriptionChange = this.susbscriptionChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange (event) {
    const _this = this;
    const { target } = event;
    const value = event.target.type === "checkbox"
      ? event.target.checked
      : event.target.value;
    const { name } = target;
    this.props.handleChange(event, value);
    setTimeout(() => {
      if (name == "bestPracticesTips" || name == "dontSendMeAnyEmails") {
        // 1 = dont sent emails 0 = sent emails
        const { state } = _this.props;
        if (state.dontSendMeAnyEmails == true) {
          _this.susbscriptionChange(1);
        } else if (state.bestPracticesTips == "0") {
          _this.susbscriptionChange(1);
        } else if (_this.props.state.bestPracticesTips == "1") {
          _this.susbscriptionChange(0);
        }
      }
    }, 1000);
  }

  susbscriptionChange (value) {
    const { profiles } = this.props;
    let data = {};
    if (value == 1) {
      // dont send emails
      data = {
        userId: profiles.user_id,
        action: "add",
        values: ["unsubscribed_wb_emails"],
      };
    } else if (value == 0) {
      // need to send emails
      data = {
        userId: profiles.user_id,
        action: "remove",
        values: ["unsubscribed_wb_emails"],
      };
    }
    wb_identify_vero(data);
  }

  render() {
    const { preference } = this.props;
    const executeModule = this.props.executeModule || false;
    const goalModule = this.props.goalModule || false;
    const { state } = this.props;
    const state_dontSendMeAnyEmails = state.dontSendMeAnyEmails;
    const dontSendMeAnyEmails = state.dontSendMeAnyEmails == 1 ? "checked" : "";
    const dailyDueEmailPreference =
      state.dailyDueEmailPreference == 1 && state_dontSendMeAnyEmails != 1
        ? "checked"
        : "";
    const dailyDigestEmailPreference =
      state.dailyDigestEmailPreference == 1 && state_dontSendMeAnyEmails != 1
        ? "checked"
        : "";
    const loopedAIEmailPreference =
      state.loopedAIEmailPreference == 1 && state_dontSendMeAnyEmails != 1
        ? "checked"
        : "";
    const okrUpdatesPrefVal =
      state.okrUpdatesPreference == 1 && state_dontSendMeAnyEmails != 1
        ? "checked"
        : "";
    const bestPracticesTips =
      state.bestPracticesTips == 1 && state_dontSendMeAnyEmails != 1
        ? "checked"
        : "";
    const {t} = this.props;
    return (
      <div style={{ width: "80%", display: "inline-block" }}>
        <div style={{ paddingLeft: "30px" }}>
          <div className="preferencesSubSubHeader">
           {t("Send me these via email") +':'}
          </div>
          <div style={{ paddingLeft: "30px" }}>
            {executeModule && (
              <div
                style={{ paddingTop: "5px", clear: "both" }}
                className="notificationEmailDiv"
              >
                <div className="notificationEmail">
                  <input
                    type="checkbox"
                    className="preference-emails"
                    id="notificationDueEmail"
                    name="dailyDueEmailPreference"
                    checked={dailyDueEmailPreference}
                    onChange={this.handleInputChange}
                  />
                  <label htmlFor="notificationDueEmail" />
                </div>
                <div className="rememberMelabel">
                  <label htmlFor="notificationDueEmail" className="myProfLabel">
                    {t("Morning due today list")}
                  </label>
                </div>
              </div>
            )}
            <div
              style={{ paddingTop: "5px", clear: "both" }}
              className="notificationEmailDiv"
            >
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="notificationDigestEmail"
                  name="dailyDigestEmailPreference"
                  checked={dailyDigestEmailPreference}
                  onChange={this.handleInputChange}
                />
                <label htmlFor="notificationDigestEmail" />
                </div>
                <div className="rememberMelabel">
                  <label
                    htmlFor="notificationDigestEmail"
                    className="myProfLabel"
                  >
                    {t("Daily digest of all my notifications")}
                </label>
              </div>
            </div>
            {executeModule && (
              <div
                style={{ paddingTop: "5px", clear: "both" }}
                className="notificationEmailDiv"
              >
                <div className="notificationEmail">
                  <input
                    type="checkbox"
                    className="preference-emails"
                    id="notificationLoopEmail"
                    name="loopedAIEmailPreference"
                    checked={loopedAIEmailPreference}
                    onChange={this.handleInputChange}
                  />
                  <label htmlFor="notificationLoopEmail" />
                </div>
                <div className="rememberMelabel">
                  <label
                    htmlFor="notificationLoopEmail"
                    className="myProfLabel"
                  >
                   {t(`Immediate alerts as Issues change`)}
                  </label>
                </div>
              </div>
            )}
            <div
              style={{ paddingTop: "5px", clear: "both" }}
              className="notificationEmailDiv"
            >
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="okrUpdates"
                  name="okrUpdatesPreference"
                  checked={okrUpdatesPrefVal}
                  onChange={this.handleInputChange}
                />
                <label htmlFor="okrUpdates" />
              </div>
              <div className="rememberMelabel">
                <label htmlFor="okrUpdates" className="myProfLabel">
                 {t("OKR updates")}
                </label>
              </div>
            </div>
            <div
              style={{ paddingTop: "5px", clear: "both" }}
              className="notificationEmailDiv"
            >
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-best-practices-tips"
                  id="preference-best-practices-tips"
                  name="bestPracticesTips"
                  checked={bestPracticesTips}
                  onChange={this.handleInputChange}
                />
                <label htmlFor="preference-best-practices-tips" />
              </div>
              <div className="rememberMelabel">
                <label
                  htmlFor="preference-best-practices-tips"
                  className="myProfLabel"
                >
                {t("Best practices, tips, and news")}
                </label>
              </div>
            </div>
            <div
              style={{ paddingTop: "5px", clear: "both" }}
              className="notificationEmailDiv"
            >
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-dontsendmeanyemails"
                  id="notificationdontSendMeAnyEmails"
                  name="dontSendMeAnyEmails"
                  checked={dontSendMeAnyEmails}
                  onChange={this.handleInputChange}
                />
                <label htmlFor="notificationdontSendMeAnyEmails" />
              </div>
              <div className="rememberMelabel">
                <label
                  htmlFor="notificationdontSendMeAnyEmails"
                  className="myProfLabel"
                >
                {t("Don't send me any emails")}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const FeedbackPreferences = (props) => {
  const { state, showFeedback, showFeedbackEmail, showFeedbackSlack, showFeedbackTeams, t } = props;
  const feedbackForEmail = state.feedbackForEmail === 1;
  const feedbackForSlack = state.feedbackForSlack === 1;
  const feedbackForTeams = state.feedbackForTeams === 1;
  
  const handleCheckboxChange = (event) => {
    const value = event.target.checked ? 1 : 0;
    props.handleChange(event, value);
  };

  return (
    <>
      {showFeedback && (
        <div style={{ paddingLeft: '30px', marginTop: '10px' }}>
          <div className="preferencesSubSubHeader">{t('Send me notifications to') + ':'}</div>
          {showFeedbackEmail && (
            <div style={{ paddingLeft: '30px' }}>
              <div style={{ paddingTop: '5px' }} className="notificationEmailDiv">
                <div className="notificationEmail">
                  <input
                    type="checkbox"
                    className="preference-emails"
                    id="enableFeedbackForEmail"
                    name="feedbackForEmail"
                    checked={feedbackForEmail}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="enableFeedbackForEmail" />
                </div>
                <div className="rememberMelabel">
                  <label htmlFor="enableFeedbackForEmail" className="ccLabel">
                    {t('Email')}
                  </label>
                </div>
              </div>
            </div>
          )}
          {showFeedbackSlack && (
            <div style={{ paddingLeft: '30px' }}>
              <div style={{ paddingTop: '5px' }} className="notificationEmailDiv">
                <div className="notificationEmail">
                  <input
                    type="checkbox"
                    className="preference-emails"
                    id="slackEnableFeedback"
                    name="feedbackForSlack"
                    checked={feedbackForSlack}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="slackEnableFeedback" />
                </div>
                <div className="rememberMelabel">
                  <label htmlFor="slackEnableFeedback" className="ccLabel">
                    {t('Slack')}
                  </label>
                </div>
              </div>
            </div>
          )}
          {showFeedbackTeams && (
            <div style={{ paddingLeft: '30px' }}>
              <div style={{ paddingTop: '5px' }} className="notificationEmailDiv">
                <div className="notificationEmail">
                  <input
                    type="checkbox"
                    className="preference-emails"
                    id="teamsEnableFeedback"
                    name="feedbackForTeams"
                    checked={feedbackForTeams}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="teamsEnableFeedback" />
                </div>
                <div className="rememberMelabel">
                  <label htmlFor="teamsEnableFeedback" className="ccLabel">
                    {t('Microsoft Teams')}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

const CalibrateCelebratePreferences = (props) => {

  const { state, showCnC, showCnCEmail, showSlack, showTeams, showWebex, t } = props;

  const calib_teams = state.calib_teams == 1 ? true : false;
  const celeb_teams = state.celeb_teams == 1 ? true : false;

  const cncForEmail = state.cncForEmail == 1 ? true : false;
  const cncForSlack = state.cncForSlack == 1 ? true : false;
  const cncForTeams = state.cncForTeams == 1 ? true : false;
  const cncForWebex = state.cncForWebex == 1 ? true : false;

  const cncForManager = state.cncForManager == 1 ? true : false;
  const cncForCoManager = state.cncForCoManager == 1 ? true : false;
  const cncForNonManager = state.cncForNonManager == 1 ? true : false;
  const cncGenAiSummaryBrief = state.cncGenAiSummaryBrief == 1 ? true : false;
  const isCncGenAiSummaryBriefEnabled = window?.wbConfig?.isCncGenAiCalibrateEnabled ?? false;

  const dontSendMeAnyEmails = state.dontSendMeAnyEmails == "0" ? true : false;
  let [menuOpen, setMenuOpen] = useState(false);

  let [startWeekValue, setStartWeekValue] = useState(state.calib_teams_nudge_on);

  const handleCheckboxChange = (event) => {
    const value = event.target.checked ? 1 : 0;
    props.handleChange(event, value);
  };

  useEffect(() => {
    const event = { target: { name: "calib_teams_nudge_on" } };
    if (state.calib_teams_nudge_on !== startWeekValue) {
      props.handleChange(event, startWeekValue);
    }
  }, [startWeekValue]);
  return (
    <>
      <div>
        {showCnC &&
        <div style={{ paddingLeft: "30px" }}>
          <div className="preferencesSubSubHeader">{t("I want to receive")+':'} </div>
          <div style={{ paddingLeft: "30px" }}>
            <div
              style={{ paddingTop: "5px" }}
              className="notificationEmailDiv"
            >
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="teamsStartWeekCalibrate"
                  name="calib_teams"
                  checked={calib_teams}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="teamsStartWeekCalibrate" />
              </div>
              <div className="rememberMelabel">
                <label htmlFor="teamsStartWeekCalibrate" className="ccLabel">
                {t("Beginning of week Calibrate nudges")}
                </label>
              </div>
              <div className="ccButtonWrapper">
                {t("On")}
                <button
                  className="ccButton"
                  onClick={() => setMenuOpen(!menuOpen)}
                >
                  {startWeekValue && startWeekValue == "0"
                    ? "Sunday"
                    : "Monday"}
                  <span
                    style={
                      menuOpen ? {} : { transform: "rotate(180deg)" }
                    }
                    className="ccButtonArrow icon icon-outline-keyboard_arrow_up-24px"
                   />
                </button>
              </div>
            </div>
            {menuOpen && (
              <StartOfWeekMenu
                setMenuOpen={setMenuOpen}
                setStartValue={setStartWeekValue}
                t = {t}
              />
            )}
            <div
              style={{ paddingTop: "5px", clear: "both" }}
              className="notificationEmailDiv"
            >
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="teamsEndWeekCelebrate"
                  name="celeb_teams"
                  checked={celeb_teams}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="teamsEndWeekCelebrate" />
              </div>
              <div className="rememberMelabel">
                <label htmlFor="teamsEndWeekCelebrate" className="ccLabel">
                  {t("End of week Celebrate updates")}
                </label>
              </div>
            </div>
          </div>
        </div>
         }
      </div>
      <div>
        <div style={{paddingLeft: "30px", marginTop: "10px"}}>

          <div className="preferencesSubSubHeader">{t("Get updates for")+':'} </div>

          <div style={{paddingLeft: "30px"}}>
            <div style={{paddingTop: "5px"}} className="notificationEmailDiv">
              <div className="notificationEmail">
                <input
                    type="checkbox"
                    className="preference-emails"
                    id="teamsManageCnC"
                    name="cncForManager"
                    checked={cncForManager}
                    onChange={handleCheckboxChange}
                />
                <label htmlFor="teamsManageCnC"/>
              </div>
              <div className="rememberMelabel">
                <label htmlFor="teamsManageCnC" className="ccLabel">
                 {t("Teams I manage")}
                </label>
              </div>
            </div>
          </div>
          <div style={{ paddingLeft: "30px" }}>
            <div style={{ paddingTop: "5px" }} className="notificationEmailDiv">
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="teamsCoManageCnC"
                  name="cncForCoManager"
                  checked={cncForCoManager}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="teamsCoManageCnC" />
              </div>
              <div className="rememberMelabel">
                <label htmlFor="teamsCoManageCnC" className="ccLabel">
                  {t("Teams I co-manage")}
                </label>
              </div>
            </div>
          </div>
          <div style={{ paddingLeft: "30px" }}>
            <div style={{ paddingTop: "5px" }} className="notificationEmailDiv">
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="teamsNonManagerCnC"
                  name="cncForNonManager"
                  checked={cncForNonManager}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="teamsNonManagerCnC" />
              </div>
              <div className="rememberMelabel">
                <label htmlFor="teamsNonManagerCnC" className="ccLabel">
                  {t("My overdue key results")}
                </label>
              </div>
            </div>
          </div>
          {
            isCncGenAiSummaryBriefEnabled && (
            <div style={{ paddingLeft: "30px" }}>
            <div style={{ paddingTop: "5px" }} className="notificationEmailDiv">
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="genAiSummaryBrief"
                  name="cncGenAiSummaryBrief"
                  checked={cncGenAiSummaryBrief}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="genAiSummaryBrief" />
              </div>
              <div className="rememberMelabel">
                <label htmlFor="genAiSummaryBrief" className="ccLabel">
                  {t("Generate AI Calibrate Brief")}
                </label>
              </div>
              </div>
            </div>)
          }
        </div>
      </div>
      {showCnC &&

      <div>
        <div style={{ paddingLeft: "30px", marginTop: "10px" }}>
          <div className="preferencesSubSubHeader">{t("Send me updates in")+':'}</div>
          {showCnCEmail &&
              dontSendMeAnyEmails &&
              <div style={{ paddingLeft: "30px" }}>
                <div style={{ paddingTop: "5px" }} className="notificationEmailDiv">
                  <div className="notificationEmail">
                    <input
                      type="checkbox"
                      className="preference-emails"
                      id="enableCnCForEmail"
                      name="cncForEmail"
                      checked={cncForEmail}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="enableCnCForEmail" />
                  </div>
                  <div className="rememberMelabel">
                    <label htmlFor="enableCnCForEmail" className="ccLabel">
                      {t("Email")}
                    </label>
                  </div>
                </div>
              </div>
          }
          {showSlack &&
          <div style={{ paddingLeft: "30px" }}>
            <div style={{ paddingTop: "5px" }} className="notificationEmailDiv">
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="slackEnableCnC"
                  name="cncForSlack"
                  checked={cncForSlack}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="slackEnableCnC" />
              </div>
              <div className="rememberMelabel">
                <label htmlFor="slackEnableCnC" className="ccLabel">
                  {t("Slack")}
                </label>
              </div>
            </div>
          </div>
          }
          {showTeams &&
          <div style={{ paddingLeft: "30px" }}>
            <div style={{ paddingTop: "5px" }} className="notificationEmailDiv">
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="teamsEnableCnC"
                  name="cncForTeams"
                  checked={cncForTeams}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="teamsEnableCnC" />
              </div>
              <div className="rememberMelabel">
                <label htmlFor="teamsEnableCnC" className="ccLabel">
                  {t("Microsoft Teams")}
                </label>
              </div>
            </div>
          </div>
          }
          {showWebex &&
          <div style={{ paddingLeft: "30px" }}>
            <div style={{ paddingTop: "5px" }} className="notificationEmailDiv">
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="webexEnableCnC"
                  name="cncForWebex"
                  checked={cncForWebex}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="webexEnableCnC" />
              </div>
              <div className="rememberMelabel">
                <label htmlFor="webexEnableCnC" className="ccLabel">
                  {t("Webex")}
                </label>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </>
  );
};

const StartOfWeekMenu = (props) => {
  const MenuRef = useRef(null);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (MenuRef.current && !MenuRef.current.contains(event.target)) {
      props.setMenuOpen(false);
    }
  };

  const handleMenuClick = (val) => {
    val ? props.setStartValue("1") : props.setStartValue("0");
    props.setMenuOpen(false);
  };

  const {t} = props;

  return (
    <div className="ccWeekMenu" ref={MenuRef}>
      <Menu.Item>
        <span onClick={() => handleMenuClick(true)}>{t("Monday")}</span>
      </Menu.Item>
      <Menu.Item>
        <span onClick={() => handleMenuClick(false)}>{t("Sunday")} </span>
      </Menu.Item>
    </div>
  );
};

class Tools extends React.Component {
  constructor (props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    const { name } = target;
    this.props.handleChange(event, value);
  }

  render() {
    const { preference } = this.props;
    const { state } = this.props;
    const tooltip = state.tooltip == 1 ? "checked" : "";
    const updateMetricAiEmail = state.updateMetricAiEmail == 1 ? "checked" : "";
    const {t} = this.props
    const activityTypeName = getAiTypeActionLabel().toLowerCase();
    return (
      <div>
        <div style={{ paddingLeft: "30px" }}>
          <div style={{ paddingLeft: "30px" }}>
            <div
              style={{ paddingTop: "5px" }}
              className="notificationEmailDiv notificationToolTipDiv"
            >
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  id="user-tooltip"
                  name="tooltip"
                  checked={tooltip}
                  onChange={this.handleInputChange}
                />
                <label htmlFor="user-tooltip" />
              </div>
              <div className="rememberMelabel">
                <label htmlFor="tooltiplabel" className="myProfLabel">
                 {t("Display tool tips on rollover")}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div style={{ paddingLeft: "30px" }}>
          <div style={{ paddingLeft: "30px" }}>
            <div
              style={{ paddingTop: "5px", clear: "both" }}
              className="notificationEmailDiv"
            >
              <div className="notificationEmail">
                <input
                  type="checkbox"
                  className="preference-emails"
                  id="notificationUpdateMetricAi"
                  name="updateMetricAiEmail"
                  checked={updateMetricAiEmail}
                  onChange={this.handleInputChange}
                />
                <label htmlFor="notificationUpdateMetricAi" />
              </div>
              <div className="rememberMelabel">
                <label
                  htmlFor="notificationUpdateMetricAi"
                  className="myProfLabel"
                >
                 {t(`Don't generate metric update ${activityTypeName}s`)}
                </label>
              </div>
            </div>
          </div>
        </div>

        {/*<div style={{ paddingLeft: "30px" }}>*/}
        {/*  <div style={{ paddingLeft: "30px" }}>*/}
        {/*    <div*/}
        {/*      style={{ paddingTop: "5px", clear: "both" }}*/}
        {/*      className="notificationEmailDiv"*/}
        {/*    >*/}
        {/*      <div className="notificationEmail">*/}
        {/*        <input*/}
        {/*          type="checkbox"*/}
        {/*          className="use-vnext"*/}
        {/*          id="useVNext"*/}
        {/*          name="useVNext"*/}
        {/*          checked={useVNext}*/}
        {/*          onChange={this.handleInputChange}*/}
        {/*        />*/}
        {/*        <label htmlFor="useVNext" />*/}
        {/*      </div>*/}
        {/*      <div className="rememberMelabel">*/}
        {/*        <label*/}
        {/*          htmlFor="useVNext"*/}
        {/*          className="myProfLabel"*/}
        {/*        >*/}
        {/*          Use new vNext UI experience*/}
        {/*        </label>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
    );
  }
}

class WorkstreamViewPreferences extends React.Component {

  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { state } = this.props;
    /* if(state.workViewPagePref == '' ||  state.workViewPagePref == null){
            this.props.handleNewChange('workViewPagePref',0);
        } */
  }

  handleInputChange(event) {
    const { target } = event;
    const { value } = event.target;
    const { name } = target;
    this.props.handleChange(event, value);
  }

  render() {
    const {t} = this.props
    const { preference } = this.props;
    const { state } = this.props;
    let BoardCheck = "";
    let ListCheck = "";
    if (state.workViewPagePref == 0) {
      BoardCheck = "checked";
    }
    if (state.workViewPagePref == 1) {
      ListCheck = "checked";
    }
    if (state.workViewPagePref == "" || state.workViewPagePref == null) {
      BoardCheck = "checked";
    }
    return (
      <div style={{ paddingLeft: "50px" }} className="start_page_pref_div">
        <div className="preferencesSubSubHeader">
          <img
            style={{ paddingLeft: "0px", paddingRight: "10px" }}
            className="startPageImgs"
            src={`${wbConfig.baseUrl}/images/icons/menu/new/small_ws_blue.png`}
            alt=""
          />
          {t("Workstreams")}:
        </div>
        <div
          className="startPageImgDiv"
          style={{
            display: "inline-block",
            marginLeft: "35px",
            paddingRight: "39px",
          }}
        >
          <input
            type="radio"
            name="workViewPagePref"
            id="wsBoard"
            value="0"
            checked={BoardCheck}
            onChange={this.handleInputChange}
          />
          <label
            htmlFor="wsBoard"
            className="start_page_pref_label myProfLabel"
          >
            {t("Board")}
          </label>
        </div>
        <div
          className="startPageImgDiv"
          style={{
            display: "inline-block",
            paddingRight: "45px",
            marginBottom: "15px",
          }}
        >
          <input
            type="radio"
            name="workViewPagePref"
            id="wsList"
            value="1"
            checked={ListCheck}
            onChange={this.handleInputChange}
          />
          <label htmlFor="wsList" className="start_page_pref_label myProfLabel">
           {t("List")}
          </label>
        </div>
      </div>
    );
  }
}

class StartPage extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { state } = this.props;
    /* if(state.startPagePreference == '' || state.startPagePreference == null){
            this.props.handleNewChange('startPagePreference',1)
        } */
  }

  handleInputChange(event) {
    const { target } = event;
    const { value } = event.target;
    const { name } = target;
    this.props.handleChange(event, value);
  }

  render () {
    const { t } = this.props;
    const { preference } = this.props;
    const { state } = this.props;
    let StartThisWeek = "";
    let StartAllMyWork = "";
    let StartMyGoals = "";
    let StartHeatmap = "";
    let StartTimeline = "";
    let StartToday = "";
    let StartRbr = "";
    let StartScorecard = "";
    let ScorecardError = state.scorecardError;
    if (state.startPagePreference != "" && state.startPagePreference == 7) {
      StartRbr = "checked";
    }
    if (state.startPagePreference != "" && state.startPagePreference == 8) {
      StartScorecard = "checked";
    }
    if (state.startPagePreference != "" && state.startPagePreference == 1) {
      StartThisWeek = "checked";
    }
    if (state.startPagePreference != "" && state.startPagePreference == 2) {
      StartAllMyWork = "checked";
    }
    if (state.startPagePreference != "" && state.startPagePreference == 6) {
      StartToday = "checked";
    }
    if (state.startPagePreference != "" && state.startPagePreference == 3) {
      StartMyGoals = "checked";
    }
    if (state.startPagePreference != "" && state.startPagePreference == 4) {
      StartHeatmap = "checked";
    }
    if (state.startPagePreference != "" && state.startPagePreference == 5) {
      StartTimeline = "checked";
    }
    if (state.startPagePreference == "" || state.startPagePreference == null) {
      StartThisWeek = "checked";
    }
    const executeModule = this.props.executeModule || false;
    const goalModule = this.props.goalModule || false;
    return (
      <div style={{ paddingLeft: "50px" }} className="start_page_pref_div">
        {this.props.isEntCust && (
          <>
            <div className="startPageImgDiv">
              <img
                className="startPageImgs"
                src={`${wbConfig.baseUrl}/images/icons/menu/new/scorecard_blue.png`}
                alt="Scorecards"
              />
              <input
                  type="radio"
                  name="startPagePreference"
                  id="scorecardStart"
                  value="8"
                  checked={StartScorecard}
                  onChange={this.handleInputChange}
              />
              <label
                  htmlFor="scorecardStart"
                  className="start_page_pref_label myProfLabel"
              >
                {t('Scorecard')}
                { ScorecardError && (
                  <ErrorOutlineOutlinedIcon
                    title="The Scorecard previously set as your start page has been deleted, or your viewing permissions have been removed."
                    aria-label="Scorecard Start Page Error"
                    color="error"
                    fontSize="small"
                    style={{ marginLeft: '2px' }}
                  />
                )}
              </label>
            </div>
            <div style={{ paddingBottom: "15px", paddingLeft: "35px" }}>
              {StartScorecard && (
                  <StartPageScorecard
                      preference={preference}
                      handleChange={this.props.handleChange}
                  />
              )}
            </div>
            <div className="startPageImgDiv">
              <img
                className="startPageImgs"
                style={{ width: "22px", paddingRight: "8px" }}
                src={`${wbConfig.baseUrl}/images/icons/menu/new/small_review_blue.png`}
                alt="Biz Review"
              />
              <input
                type="radio"
                name="startPagePreference"
                id="rbrStart"
                value="7"
                checked={StartRbr}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor="rbrStart"
                className="start_page_pref_label myProfLabel"
              >
               {t('Biz Review')}
              </label>
            </div>
            <div style={{ paddingBottom: "15px", paddingLeft: "35px" }}>
              {StartRbr && (
                <StartPageRBR
                  preference={preference}
                  handleChange={this.props.handleChange}
                />
              )}
            </div>
          </>
        )}

        {executeModule && (
          <div>
            <div className="preferencesSubSubHeader">
              <img
                style={{ paddingLeft: "0px", paddingRight: "10px" }}
                className="startPageImgs"
                src={`${wbConfig.baseUrl}/images/icons/menu/new/smallmy_work_blue.png`}
                alt=""
              />
              {t("My Work")}:
            </div>
            <div
              className="startPageImgDiv"
              style={{ marginLeft: "35px", display: "inline-block" }}
            >
              <input
                type="radio"
                name="startPagePreference"
                id="thisWeekStart"
                value="1"
                checked={StartThisWeek}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor="thisWeekStart"
                className="start_page_pref_label myProfLabel"
                style={{ paddingRight: "15px" }}
              >
                {t("This Week")}
              </label>
            </div>
            <div
              className="startPageImgDiv"
              style={{
                paddingRight: "15px",
                display: "inline-block",
              }}
            >
              <input
                type="radio"
                name="startPagePreference"
                id="allMyWorkStart"
                value="2"
                checked={StartAllMyWork}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor="allMyWorkStart"
                className="start_page_pref_label myProfLabel"
                style={{ paddingRight: "15px" }}
              >
                {t("All My Work")}
              </label>
            </div>
            <div
              className="startPageImgDiv"
              style={{ display: "inline-block", marginBottom: "15px" }}
            >
              <input
                type="radio"
                name="startPagePreference"
                id="todayStart"
                value="6"
                checked={StartToday}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor="todayStart"
                className="start_page_pref_label myProfLabel"
                style={{ paddingRight: "15px" }}
              >
               {t("Today")}
              </label>
            </div>
          </div>
        )}

        {goalModule && (
          <div>
            <div className="preferencesSubSubHeader">
              <img
                style={{ paddingLeft: "0px", paddingRight: "10px" }}
                className="startPageImgs"
                src={`${wbConfig.baseUrl}/images/icons/menu/new/small_objective_blue.png`}
                alt=""
              />
              {t("Objectives")}:
            </div>
            <div
              className="startPageImgDiv"
              style={{
                display: "inline-block",
                marginLeft: "35px",
                paddingRight: "22px",
              }}
            >
              <input
                type="radio"
                name="startPagePreference"
                id="myGoalStart"
                value="3"
                checked={StartMyGoals}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor="myGoalStart"
                className="start_page_pref_label myProfLabel"
              >
               {t("My OKRs")}
              </label>
            </div>
            {state.disableHeatmap ? (
              <div
                className="startPageImgDiv"
                style={{ display: "inline-block", paddingRight: "45px" }}
              >
                <input
                  type="radio"
                  name="startPagePreference"
                  id="heatMapStart"
                  value="4"
                  checked={StartHeatmap}
                  onChange={this.handleInputChange}
                />
                <label
                  htmlFor="heatMapStart"
                  className="start_page_pref_label myProfLabel"
                >
                 {t("Heatmap")}
                </label>
              </div>
            ) : (
              ""
            )}

            {this.props.goalModule == 2 && (
              <div
                className="startPageImgDiv"
                style={{ display: "inline-block" }}
              >
                <input
                  type="radio"
                  name="startPagePreference"
                  id="timeLineStart"
                  value="5"
                  checked={StartTimeline}
                  onChange={this.handleInputChange}
                />
                <label
                  htmlFor="timeLineStart"
                  className="start_page_pref_label myProfLabel"
                >
                  {t("Timeline")}
                </label>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

class StartPageRBR extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      options: [],
      selected: null,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount () {
    $.get(`${wbConfig.baseUrl}/rbr/rbrList`, ({ data }) => {
      const {
        favorites,
        myRbrs,
        sharedRbrs
      } = data;
      const personalRbr = { id: '', name: 'Personal RBR' };
      const options = uniqBy(
        [
          personalRbr,
          ...favorites,
          ...myRbrs,
          ...sharedRbrs
        ],
        (rbr) => rbr.id
      );
      const selected = options.find(r => r.id == this.props.preference.startPageRBRId) || personalRbr;
      this.setState({ options, selected });
    });
  }

  handleSelect (e, selected) {
    if (selected) {
      this.props.handleChange({ target: { name: 'startPageRBRId' }}, selected.id);
      this.setState({ selected });
    }
  }

  render () {
    return (
      <>
        <Autocomplete
          className="start-page-rbr"
          value={this.state.selected}
          options={this.state.options}
          getOptionLabel={({ name }) => name}
          isRequired={true}
          onChange={this.handleSelect}
          startMatch={false}
        />
      </>
    );
  }
}

class StartPageScorecard extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      options: [],
      selected: null,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount () {
    $.get(`${wbConfig.baseUrl}/vnext/rbr/items?orderBy=asc&sortBy=name&limit=500&start=0&isArchived=0&omitCollections=1&omitRBRs=1`,
      ({ items }) => {
        const options = items;
        const selected = options.find(r => r.id == this.props.preference.startPageScorecardId) || null;
        if (selected === null && this.props.preference.startPageScorecardId) {
          this.props.handleChange({ target: { name: 'scorecardError' } }, true);
        }
        this.setState({ options, selected });
      });
  }

  handleSelect (e, selected) {
    if (selected) {
      this.props.handleChange({ target: { name: 'startPageScorecardId' } }, selected.id);
      this.props.handleChange({ target: { name: 'scorecardError' } }, false);
      this.setState({ selected });
    }
  }
  render () {
    return (
      <>
        <Autocomplete
          className="start-page-rbr"
          value={this.state.selected}
          options={this.state.options}
          getOptionLabel={({ name }) => name}
          isRequired={true}
          onChange={this.handleSelect}
          startMatch={false}
          placeholder="Please Select A Scorecard"
        />
      </>
    );
  }
}

class ScheduledTimeOff extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserTimeOff: props.userTimeOff.length > 0,
      list: [],
      dataList: undefined,
      showScheduledPopUp: false,
    };
    this.showScheduledTime = this.showScheduledTime.bind(this);
    this.closeScheduledTime = this.closeScheduledTime.bind(this);
    this.deleteUserTimeOff = this.deleteUserTimeOff.bind(this);
  }

  showScheduledTime(e, item = null) {
    const itemid = item.id != "" ? item.id : "";
    const itemStartDate = item.start_date != "" ? item.start_date : "";
    const itemEndDate = item.end_date != "" ? item.end_date : "";

    const dataList = {
      id: itemid,
      startDate: itemStartDate,
      endDate: itemEndDate,
    };
    this.setState({
      dataList,
      showScheduledPopUp: true,
    });
  }

  closeScheduledTime() {
    this.setState({
      dataList: undefined,
      showScheduledPopUp: false,
    });
  }

  deleteUserTimeOff(id) {
    const { actions } = this.props;
    actions.DeleteUserTimeOff(id);
    $.post(
      `${wbConfig.baseUrl}/user/profile/DeleteUserTimeOff`,
      { id },
      () => {}
    );
  }

  render() {
    const userTimeOffs = this.props.userTimeOff;
    const { dataList, showScheduledPopUp } = this.state;
    const { t } = this.props
    return (
      <div>
        {showScheduledPopUp &&
        <ScheduledPopUp
          closeScheduledTime={this.closeScheduledTime}
          dataList={dataList}
          actions={this.props.actions}
        />}
        <div style={{ padding: "25px 0px 8px 0px", width: "78%" }}>
          <span className="capacity-preference">{t("Scheduled Time Off")}  </span>
          <span
            className="capacity-time"
            onClick={(e) => this.showScheduledTime(e, this.state.list)}
          >
            <img alt="add AI" src="../../images/icons/main_menu/add_ai_selected.png" />
           {t("Add")}
          </span>
        </div>
        <div
          style={{
            marginLeft: "22px",
            padding: "8px",
            backgroundColor: "#f1f7f8",
            width: "100%",
          }}
        >
          <span
            style={{ marginLeft: "7%", fontSize: "0.9em", color: "#999999" }}
          >
            {t("Start")}
          </span>
          <span
            style={{ marginLeft: "20%", fontSize: "0.9em", color: "#999999" }}
          >
            {t("End")}
          </span>
          <span
            style={{ marginLeft: "25%", fontSize: "0.9em", color: "#999999" }}
          >
            {t("Edit")}
          </span>
          <span
            style={{ marginLeft: "15%", fontSize: "0.9em", color: "#999999" }}
          >
            {t("Delete")}
          </span>
        </div>
        <div className="timeEditOff" />

        {this.props.userTimeOff.length > 0 ? (
          <div>
            {userTimeOffs.map((items, i) => (
              <div
                key={items.id}
                className="schCapacity displayTable schTime_"
                style={{ width: "68%" }}
                data-attr={items.id}
                data-user-id={items.uid}
              >
                <div
                  className="schTimeclassName"
                  style={{
                    marginLeft: "22px",
                    width: "100%",
                    paddingTop: "10px",
                  }}
                >
                  <span
                    className="startDate displayCell"
                    style={{
                      fontWeight: "600",
                      width: "35%",
                      fontSize: "0.9em",
                      paddingLeft: "38px",
                    }}
                  >
                    {moment
                      .unix(items.start_date)
                      .add(1, "days")
                      .format("MMM DD, YYYY")}
                  </span>
                  <span
                    className="endDate displayCell"
                    style={{
                      fontWeight: "600",
                      width: "29%",
                      fontSize: "0.9em",
                      paddingLeft: "21px",
                    }}
                  >
                    {moment
                      .unix(items.end_date)
                      .add(1, "days")
                      .format("MMM DD, YYYY")}
                  </span>
                  <span
                    className="scTimeEdit displayCell"
                    style={{ width: "20.5%", paddingLeft: "46px" }}
                    data-start={items.start_date}
                    data-end={items.end_date}
                    onClick={(e) => this.showScheduledTime(e, items)}
                  >
                    <img
                      style={{ cursor: "pointer" }}
                      className=""
                      src="../../images/icons/edit_gray_s.png"
                    />
                  </span>
                  <span
                    className="usTimeDelete displayCell"
                    style={{ width: "20%", paddingLeft: "55px" }}
                    onClick={() => this.deleteUserTimeOff(items.id)}
                  >
                    <img
                      style={{ cursor: "pointer" }}
                      className="scTimeDelete"
                      src="../../images/icons/del_gray.png"
                    />
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="placeHolderTime">
           {t("You do not have any scheduled time off at the moment.")}
          </div>
        )}
      </div>
    );
  }
}

const enhance = compose(withTranslation(), hot);
export default enhance(withTranslation()(PreferenceApp));
